export default __webpack_public_path__ + "assets/webgl/skybox_night.c80deb44.jpg";